import get from 'lodash/get';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import s from './MobileRunningMovie.module.scss';
import { MovieSchema } from '../Schemas';
import { getSentimentCount } from '../../services/sentimentServices';
import { getImagesFromCDN } from '../../services/coreUtil';
import { TYPE_LOW_PRICE_MOVIE_TICKETS } from '../../constants/moviesConst';
import MovieSentimentCount from '../MovieSentimentCount/MovieSentimentCount';
import Button from '../Button/Button';
import LazyLoad from 'react-lazyload';
import { createUrlForHref } from '../../services/urlCreator';
import cx from 'classnames';

interface Props {
	movie: any;
	hideSchema?: boolean;
	metricInfo: any;
	onProductClick?: (movie: any) => void;
	path: any;
	type?: any;
	truncateText?: boolean;
	seoRunningMovie?: boolean;
}

const MobileRunningMovie = (props: Props) => {
	const { movie, hideSchema = false, metricInfo, onProductClick = () => {}, path, type } = props;
	const sentimentCountData = getSentimentCount(metricInfo);
	let movieUrl = createUrlForHref(movie.detailUrl) || '';
	if (type === TYPE_LOW_PRICE_MOVIE_TICKETS) {
		movieUrl = movie.lowPriceUrl;
	}

	if (isEmpty(movie)) return null;

	return (
		<span
			onClick={() => {
				onProductClick && onProductClick(movie);
				props?.selectMovieSEMEvent?.();
			}}
			className={cx(s.runningMovie, { [s.seoRunningMovie]: props.seoRunningMovie })}
		>
			{!hideSchema && (
				<MovieSchema
					path={path}
					movie={movie}
					{...{
						titleKey: 'label',
						imageKey: 'image_url',
					}}
					sentimentCountData={sentimentCountData}
				/>
			)}
			<a
				href={movieUrl}
				onClick={(e) => {
					e.preventDefault();
				}}
			>
				<div className={s.imgWrapper}>
					<LazyLoad once offset={400} height={150}>
						<img
							alt={movie.label}
							src={getImagesFromCDN(movie.edgeBanner)}
							onError={(event: any) => (event.target.style.display = 'none')}
						/>
					</LazyLoad>
					<div className={s.percent}>
						<MovieSentimentCount metricInfo={metricInfo} />
					</div>
					{!!movie?.bookingStatus && <div className={s.movieTag}>{movie.bookingStatus}</div>}
				</div>
			</a>
			<div className={s.details}>
				<div className={s.rowMovie}>
					<div className={s.detMovie}>
						<a
							onClick={(e) => {
								e.preventDefault();
							}}
							className={cx(s.lineClamp, props.truncateText ? s.clampOne : s.clampTwo)}
							href={movieUrl}
						>
							{movie.label}
						</a>
						<span className={cx(s.lineClamp, s.clampOne)}>
							{!!movie.censor && <span>{movie.censor}</span>}
							{movie.language.join(', ')}
						</span>
					</div>
					<div className={s.butBook}>
						<div>
							<Button
								type="secondary"
								btnText={'Book Now'}
								onClickHandler={() => {}}
								size="medium"
							/>
						</div>
					</div>
				</div>
				{!!get(movie, 'screenFormats.length') && (
					<div className={s.tag}>
						{map(movie.screenFormats, (format) => (
							<span key={format}>{format}</span>
						))}
					</div>
				)}
			</div>
		</span>
	);
};

export default MobileRunningMovie;
